import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initFacebookPixel } from "./facebookPixel";

// auth
import Login from "./project/auth/login";
import Register from "./project/auth/register";
import ForgotPassword from "./project/auth/ForgotPassword";
import Profile from "./project/auth/Profile";

// page
import Home from "./project/page/home";
import Contact from "./project/page/contact";
import AstrologerGallery from "./project/page/astrologerGallery";
import AboutUs from "./project/page/aboutUs";

// features
import HoroscopeList from "./project/features/horoscope/HoroscopeList";
import HoroscopeDetail from "./project/features/horoscope/HoroscopeDetail";
import Blog from "./project/features/blog/blog";
import BlogDetail from "./project/features/blog/blogDetail";
import AstrologerSection from "./project/features/astrologer/AstrologerSection";
import AstrologerProfile from "./project/features/astrologer/astrologerProfile";

import ProductList from "./project/features/shop/ProductList";
import ProductDetail from "./project/features/shop/ProductDetail";
import ShopCategoryCard from "./project/features/shop/shopCategoryCard";
import Cart from "./project/features/shop/Cart";
import Checkout from "./project/features/shop/Checkout";
import TrackOrder from "./project/features/shop/TrackOrder";
import OrderCreated from "./project/features/shop/OrderCreated";
import MyOrders from "./project/features/shop/MyOrders";

//payment
import PaymentHistory from "./project/payment/PaymentHistory";  

import Homan from "./project/features/puja/homan";
import PujaDetailPage from "./project/features/puja/pujaDetailPage";
import Plan from "./project/features/plan/plan";
import PaymentSuccess from "./project/payment/PaymentSuccess";
import FaQ from "./project/features/FaQ/faq";
import FastivelCalander from "./project/features/calander/fastivelCalander";
import Panchang from "./project/features/calander/panchang";
import MonthlyPanchang from "./project/features/calander/monthlyPanchang";
import Choghadiya from "./project/features/calander/Choghadiya";
import Hora from "./project/features/calander/Hora";
import MypanchangWidget from "./project/features/calander/MypanchangWidget";
import Ashtakoot from "./project/features/matching/Ashtakoot";
import Dashakoot from "./project/features/matching/Dashakoot";
import Aggregate from "./project/features/matching/Aggregate";
import Western from "./project/features/matching/Western";
import Nakshatra from "./project/features/matching/Nakshatra";
import D1chart from "./project/features/chart/D1";

// components
import NavBar from "./project/components/navber";
import FloatingIcons from "./project/components/icon/FloatingIcons";
import HomeSlider from "./project/components/slider/homeSlider";
import SidebarOptions from "./project/components/slider/SidebarOptions";
import AstrologerSlider from "./project/components/slider/AstrologerSlider";
import Testimonial from "./project/components/Testimonial/testimonial";
import FbBooknow from "./project/components/fb_LandingPage/fbBooknow";
import FBSlider from "./project/components/fb_LandingPage/fbSlider";
import PrivacyPolicy from "./project/components/private&policy";
import TermsAndRefund from "./project/components/TermsofUse";
import Footer from "./project/components/footer";

function ScrollToPixel() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    initFacebookPixel();
  }, [location]);

  return null;
}

function AppLayout() {
  const location = useLocation();
  const hideLayout = location.pathname === "/login" || location.pathname === "/register";

  return (
    <>
      {!hideLayout && <NavBar />}
      {!hideLayout && <FloatingIcons />}

      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/AstrologerGallery" element={<AstrologerGallery />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/HoroscopeList" element={<HoroscopeList />} />
        <Route path="/horoscope/:name" element={<HoroscopeDetail />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/Blog/:id" element={<BlogDetail />} />
        <Route path="/AstrologerSection" element={<AstrologerSection />} />
        {/* <Route path="/astrologerprofile/:id"  element={<AstrologerProfile />} /> */}
        <Route path="/profile/:id" element={<AstrologerProfile />} />
       

        <Route path="/ProductList" element={<ProductList />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/ShopCategoryCard" element={<ShopCategoryCard />} />
        <Route path="/Cart" element={<Cart />} />
      <Route path="/TrackOrder/:orderId" element={<TrackOrder />} />
      <Route path="/OrderCreated/:orderId" element={<OrderCreated />} />
      <Route path="/MyOrders" element={<MyOrders />} />

      <Route path="/PaymentHistory" element={<PaymentHistory />} />

        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/Homan" element={<Homan />} />
        <Route path="/puja-detail/:id" element={<PujaDetailPage />} />
        <Route path="/Plan" element={<Plan />} />
        <Route path="/FaQ" element={<FaQ />} />
        <Route path="/FastivelCalander" element={<FastivelCalander />} />
        <Route path="/Panchang" element={<Panchang />} />
        <Route path="/MonthlyPanchang" element={<MonthlyPanchang />} />
        <Route path="/Choghadiya" element={<Choghadiya />} />
        <Route path="/Hora" element={<Hora />} />
        <Route path="/MypanchangWidget" element={<MypanchangWidget />} />
        <Route path="/Ashtakoot" element={<Ashtakoot />} />
        <Route path="/Dashakoot" element={<Dashakoot />} />
        <Route path="/Aggregate" element={<Aggregate />} />
        <Route path="/Western" element={<Western />} />
        <Route path="/Nakshatra" element={<Nakshatra />} />
        <Route path="/D1chart" element={<D1chart />} />
        <Route path="/TermsAndRefund" element={<TermsAndRefund />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/HomeSlider" element={<HomeSlider />} />
        <Route path="/SidebarOptions" element={<SidebarOptions />} />
        <Route path="/Testimonial" element={<Testimonial />} />
        <Route path="/FbBooknow" element={<FbBooknow />} />
        <Route path="/FBSlider" element={<FBSlider />} />
        <Route path="/AstrologerSlider" element={<AstrologerSlider />} />
      </Routes>

      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToPixel />
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;